import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'
import { Variant as TextClass, typographyMap } from '../Text/Text.styles'

const colors = {
  urgent: '#A72121',
  high: '#DC890D',
  normal: '#60B878',
  low: '#ABBED1'
}

export const Tag = styled.span<{
  heightClass: HeightClass
  level: keyof typeof colors
}>`
  ${({ theme, heightClass }) =>
    typographyMap[theme.priorityTag[heightClass].textClass as TextClass]}
  padding: ${({ theme, heightClass }) =>
    theme.priorityTag[heightClass].padding}px;
  background: ${({ level }) => colors[level]};
  color: ${({ level }) => (level === 'urgent' ? '#FFF' : '#303032')};
`
